import { useRouter } from 'next/router';
import { usePageFiltersContext } from '@/creditflowresearch/application/PageFilters/PageFiltersContext';
import { ThemeType } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/themeTypes';
import { useParentPageContext } from '@/creditflowresearch/application/ParentPageContext';
import {
  buildLink,
  buildTooltip,
  resolveLink,
} from '@/creditflowresearch/ui/components/creditFlow/articles/common/useGetLinkToAllArticles';

export const useGetLinkToAllArticles = (themeType: ThemeType) => {
  const { query } = useRouter();
  const { deal } = useParentPageContext();
  const { productFilters, regionFilters, accessibleProducts, accessibleRegions } = usePageFiltersContext();

  const { product, region, path, query: configuredQuery } = resolveLink({
    query,
    deal,
    filters: {
      products: productFilters,
      regions: regionFilters,
      accessibleProducts,
      accessibleRegions,
    },
  });

  return {
    link: buildLink(themeType, product, region, configuredQuery, path),
    tooltip: buildTooltip(themeType, product, region, query.markets),
  };
};
